import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * Respuesta del tab Totales (detalle liquidación agencia) vía
 * dbo.sp_DetalleLiqAgenciaTotales: columnas fijas, 2 recordsets (filas + totales).
 */
export class LiquidacionAgenciaTotalesTabDto {
  @ApiProperty({
    description: 'Cabeceras de columnas (orden como retorna el SP)',
    type: [String],
    example: [
      'NumeroLiquidacion',
      'Nave',
      'POL',
      'ETD',
      'Exportador',
      'CNTR',
      'PLTS',
      'MontoOrdenesServicios',
      'TotalTraspasoBruto',
    ],
  })
  columns!: string[];

  @ApiProperty({
    description: 'Filas de detalle por nave (sin la fila Totales)',
    type: 'array',
    items: { type: 'object', additionalProperties: true },
  })
  rows!: Record<string, string | number | null>[];

  @ApiPropertyOptional({
    description: 'Fila de totales (segundo recordset del SP)',
    type: 'object',
    additionalProperties: true,
  })
  totalsRow!: Record<string, string | number | null> | null;

  @ApiProperty({
    description: 'Cantidad de filas de detalle (excluye totales)',
    example: 3,
  })
  totalFilas!: number;
}
